// Thin wrapper around localStorage with JSON codec and try/catch.
// Private rooms are never persisted in cookies — they would leak via the
// Cookie header on every request to the host and may end up in proxy logs.

const HISTORY_KEY = 'invite.history';
const HISTORY_MAX = 10;

export function loadHistory() {
  try {
    const raw = window.localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_err) {
    return [];
  }
}

export function saveHistory(history) {
  try {
    const trimmed = Array.isArray(history) ? history.slice(0, HISTORY_MAX) : [];
    window.localStorage.setItem(HISTORY_KEY, JSON.stringify(trimmed));
  } catch (_err) {
    // quota exceeded / private mode — ignore, feature is best-effort
  }
}

export { HISTORY_MAX };
